module.exports = __webpack_public_path__ + "80b4ce7f596c407efe2fbe1fc8edbb13.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/server-product/images/jianyan.png
// module id = 2472
// module chunks = 31